<template>
  <button
      :class="buttonClass"
      :disabled="disabled || loading"
      @click="$emit('click')"
  >
    <span v-if="loading" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
    <span v-if="icon && !loading" class="mr-2">
      <i :class="icon"></i>
    </span>
    <slot />
  </button>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    type: {
      type: String,
      default: 'primary', // ex: 'danger', 'info', 'warning'
    },
    size: {
      type: String,
      default: 'md', // ex: 'sm', 'lg'
    },
    icon: {
      type: String,
      default: '', // ex: 'bi bi-plus'
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    outline: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    buttonClass() {
      const bootstrap = `btn${this.outline ? '-outline' : ''}-${this.type}`;
      const bulma = `is-${this.type}`;
      return [
        'btn',         // Bootstrap
        bootstrap,     // btn-primary, btn-outline-danger...
        `btn-${this.size}`, // sm, md, lg
        bulma,         // Bulma compatibility
      ];
    },
  },
};
</script>

<style scoped>
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>